import { Tier, Frequency } from '../subscriptions.constants';
import { OrderConfirmation } from '../../store/checkout/OrderConfirmation';
import { PurchaseSubscriptionForm } from './PurchaseSubscriptionForm';
import { usePurchase } from '../../../context/purchase/usePurchase';
import { useTheme } from '../../../context/theme/useTheme';
import { Elements } from '@stripe/react-stripe-js';
import { getStripeAppearance } from '../../store/constants';
import { useAuth } from '../../../context/auth/useAuth';
import { LoginCard } from '../../tip/LoginCard';
import { BillingToggle } from './BillingToggle';
import { LoadingLines } from '../../_misc/loaders/LoadingLines';

export const PurchaseContainer = (props: Props) => {
  const { tier, frequency, updateFrequency, onCancel, onConfirm, clientSecret, isDisabled } = props;
  const { currentUser } = useAuth();
  const { stripePromise, completedSubscription, setCompletedSubscription, toggleSubscribing } = usePurchase();
  const { colorName, isDarkMode } = useTheme();

  return (
    <>
      <div className="isolate px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-lg text-center">
          <h2 className="mb-5 text-balance text-5xl font-semibold tracking-tight text-gray-800">
            Become a {tier.tierTitle}
          </h2>
          <div className="flex justify-center">
            <BillingToggle tier={tier} frequency={frequency} setFrequency={updateFrequency} />
          </div>
        </div>

        {currentUser != null ? (
          <>
            {clientSecret ? (
              <Elements
                stripe={stripePromise}
                options={{
                  clientSecret,
                  appearance: getStripeAppearance(colorName, isDarkMode),
                }}
              >
                <PurchaseSubscriptionForm
                  tier={tier}
                  frequency={frequency}
                  onCancel={onCancel}
                  onConfirm={onConfirm}
                  clientSecret={clientSecret}
                  isDisabled={isDisabled}
                />
              </Elements>
            ) : (
              <div className="flex items-center justify-center p-5">
                <LoadingLines />
              </div>
            )}
          </>
        ) : (
          <LoginCard />
        )}
      </div>

      <OrderConfirmation
        isToggled={completedSubscription != null}
        className="top-0"
        onContinue={() => {
          setCompletedSubscription(undefined);
          setTimeout(() => toggleSubscribing(), 1000);
        }}
      />
    </>
  );
};

type Props = {
  tier: Tier;
  frequency: Frequency;
  updateFrequency: (freq: Frequency) => void;
  onCancel: () => void;
  onConfirm: () => Promise<void>;
  clientSecret?: string;
  isDisabled: boolean;
};
